// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"4883b142d95096141731","777":"6cef2e1021e7f6fb697b"}[chunkId] + ".js";
};